import React, { ReactNode } from 'react';

import { BoxProps, CircularProgress } from '@mui/material';

import { Body } from './styled';

interface IAsyncProps extends BoxProps {
	loading?: boolean;
	children?: ReactNode;
}

function Async({ loading, children, ...props }: IAsyncProps) {
	return loading ? (
		<Body {...props}>
			<CircularProgress />
		</Body>
	) : (
		// eslint-disable-next-line react/jsx-no-useless-fragment
		<>{children}</>
	);
}

export default Async;
